import CookieBanner from "./CookieBanner";

const els = document.querySelectorAll('.cookie-banner');

for (let el of els) {
    CookieBanner(el);
}
